import type { ReactNode } from 'react';
import classnames from 'classnames';
import { Icon, IconColor } from '../../common';
import styles from './RoundedCheckMarkButton.module.css';

interface IRoundedCheckMarkButtonProps {
    automation?: string;
    children?: ReactNode;
    disabled?: boolean;
    hasError?: boolean;
    icon?: string;
    isChecked?: boolean;
    onClick?: () => void;
    tabIndex?: number;
}

/**
 * @deprecated use ksyos/design-system components instead. Remove if no longer used.
 */
export function RoundedCheckMarkButton(props: IRoundedCheckMarkButtonProps) {
    let className;

    if (props.isChecked) {
        className = classnames(styles.normal, styles.checked, 'mb-2');
    } else {
        className = classnames(styles.normal, 'mb-2');
    }

    return (
        <button
            className={className}
            disabled={props.disabled}
            onClick={props.onClick}
            tabIndex={props.tabIndex}
            type="button"
        >
            {props.children}
            {getIcon()}
        </button>
    );

    function getIcon() {
        if (props.isChecked) {
            return (
                <Icon
                    className={styles.checkedIcon}
                    color={IconColor.white}
                    icon={'check'}
                />
            );
        } else if (props.icon) {
            return (
                <Icon
                    className={styles.checkedIcon}
                    color={IconColor.secondary}
                    icon={props.icon}
                />
            );
        }

        return null;
    }
}
